<div class="grid grid-cols-1 md:grid-cols-3 gap-4 my-6">

  <!-- Instrukcja integracji przez wtyczkę -->
  <div class="h-full bg-gradient-to-br from-red-50 to-red-100 dark:from-red-900/20 dark:to-red-800/20 border border-red-200 dark:border-red-700 rounded-lg p-5 hover:shadow-lg transition-all duration-300 cursor-pointer group"
       (click)="openPluginInstruction()">
    <div class="flex flex-col items-center text-center gap-3 h-full">
      <div class="w-14 h-14 bg-red-500 dark:bg-red-600 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
        <i class="pi pi-book text-white text-2xl"></i>
      </div>
      <h3 class="font-bold text-gray-800 dark:text-gray-100 text-lg">
        {{ 'companies.instructions.pluginIntegration' | translate }}
      </h3>
      <p class="text-sm text-gray-600 dark:text-gray-300 flex-1">
        {{ 'companies.instructions.pluginIntegrationDescription' | translate }}
      </p>
      <div class="pt-2">
        <span class="text-red-600 dark:text-red-400 font-medium flex items-center gap-2 group-hover:gap-3 transition-all">
          {{ 'companies.instructions.readMore' | translate }} <i class="pi pi-arrow-right text-xs"></i>
        </span>
      </div>
    </div>
  </div>

  <!-- Tutorial Video -->
  <div class="h-full bg-gradient-to-br from-blue-50 to-blue-100 dark:from-blue-900/20 dark:to-blue-800/20 border border-blue-200 dark:border-blue-700 rounded-lg p-5 hover:shadow-lg transition-all duration-300 cursor-pointer group"
       (click)="openTutorialVideo()">
    <div class="flex flex-col items-center text-center gap-3 h-full">
      <div class="w-14 h-14 bg-blue-500 dark:bg-blue-600 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
        <i class="pi pi-play text-white text-2xl"></i>
      </div>
      <h3 class="font-bold text-gray-800 dark:text-gray-100 text-lg">
        {{ 'companies.instructions.tutorialVideo' | translate }}
      </h3>
      <p class="text-sm text-gray-600 dark:text-gray-300 flex-1">
        Obejrzyj tutorial video z instrukcją
      </p>
      <div class="pt-2">
        <span class="text-blue-600 dark:text-blue-400 font-medium flex items-center gap-2 group-hover:gap-3 transition-all">
          Obejrzyj <i class="pi pi-arrow-right text-xs"></i>
        </span>
      </div>
    </div>
  </div>

  <!-- Kontakt -->
  <div class="h-full bg-gradient-to-br from-green-50 to-green-100 dark:from-green-900/20 dark:to-green-800/20 border border-green-200 dark:border-green-700 rounded-lg p-5 hover:shadow-lg transition-all duration-300 cursor-pointer group"
       (click)="openContactMail()">
    <div class="flex flex-col items-center text-center gap-3 h-full">
      <div class="w-14 h-14 bg-green-500 dark:bg-green-600 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
        <i class="pi pi-envelope text-white text-2xl"></i>
      </div>
      <h3 class="font-bold text-gray-800 dark:text-gray-100 text-lg">
        {{ 'companies.instructions.contactUs' | translate }}
      </h3>
      <p class="text-sm text-gray-600 dark:text-gray-300 flex-1">
        {{ 'companies.instructions.contactEmail' | translate }}
      </p>
      <div class="pt-2">
        <span class="text-green-600 dark:text-green-400 font-medium flex items-center gap-2 group-hover:gap-3 transition-all">
          Skontaktuj się <i class="pi pi-arrow-right text-xs"></i>
        </span>
      </div>
    </div>
  </div>

</div>
